import React, {
    createContext, useState, useMemo, 
   } from 'react';
   import PropTypes from 'prop-types';
   
   export const SideBarRefreshContext = createContext();
   
   const SideBarRefreshContextProvider = ({ children }) => {
    const [sideBarRefresh, setSideBarRefresh] = useState({
        restaurantProfileRefresh: false,
        restaurantMealSearchRefresh: false,
        restaurantMealRequestRefresh: false,
        restaurantMealRejectedRefresh: false,
        restaurantBookingRefresh: false,
        restaurantAccountRefresh: false,
        restaurantAccountApprovedRefresh: false,
        restaurantAccountRejectedRefresh: false,
        restaurantAccountPendingRefresh: false,
        restaurantUserRefresh: false,
    });


  // Memoize the context value to avoid unnecessary re-renders
  const value = useMemo(() => ({
    sideBarRefresh, setSideBarRefresh,
  }), [
    sideBarRefresh]);

   
     return (
       <SideBarRefreshContext.Provider value={value}>
         {children}
       </SideBarRefreshContext.Provider>
     );
   };
   
   SideBarRefreshContextProvider.propTypes = {
     children: PropTypes.node.isRequired,
   };
   
   export default SideBarRefreshContextProvider;
